import { useNavigate, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";

const links = [
  { label: "Leads", href: "/admin", id: "admin-nav-leads" },
  { label: "CRM", href: "/admin/crm", id: "admin-nav-crm" },
];

export const AdminNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const logout = () => {
    localStorage.removeItem("ph_token");
    navigate("/admin/login");
  };

  return (
    <header className="border-b border-white/10 bg-[#0B0B0B] sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[64px] flex items-center justify-between gap-4">
        <div className="flex items-center gap-5 min-w-0">
          <a href="/" data-testid="admin-nav-logo" className="shrink-0">
            <img src="/logo.png" alt="Purpose Haul" className="h-8 w-auto invert" />
          </a>
          <nav className="flex items-center gap-1">
            {links.map((l) => {
              const active = l.href === "/admin" ? pathname === "/admin" : pathname.startsWith(l.href);
              return (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={l.id}
                  className={`font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-2 transition-colors duration-300 ${
                    active ? "text-white border-b border-white" : "text-neutral-500 hover:text-white"
                  }`}
                >
                  {l.label}
                </a>
              );
            })}
          </nav>
        </div>
        <button
          data-testid="admin-logout-button"
          onClick={logout}
          className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-400 hover:text-white transition-colors duration-300"
        >
          <LogOut size={14} /> Logout
        </button>
      </div>
    </header>
  );
};
